import { message } from 'antd';
import { useCallback } from 'react';

export const useErrorHandler = () => {
  const handleError = useCallback((error) => {
    if (!error.response?.data) {
      message.error('An unexpected error occurred');
      return;
    }

    const { errors, message: errorMessage } = error.response.data;

    if (errors?.length) {
      errors.forEach(({ field, description }) => {
        message.error(`${field}: ${description}`);
      });
      return;
    }

    if (errorMessage) {
      message.error(errorMessage);
      return;
    }
  }, []);

  return { handleError };
};